import { TextInput } from 'components/Inputs/';
import React, { useEffect, useState } from 'react';
import { INVOICE_NINJA } from 'constants/inventory';
import { FlexCol, FlexRow } from 'components/Layout/';
import { Collapsible } from 'components/Collapsible/';
import { FormGroup } from 'components/Settings/styles';
import { isValidUrl, capitalizeFirstLetter } from 'utils/';
import { ReactComponent as ArrowIcon } from 'icons/tick.svg';
import { ReactComponent as EditIcon } from 'icons/pencil_circle.svg';
import { CancelButton, RoundButton, DeleteButton } from 'components/Buttons/';

export function Accounting({ onSubmit, onDelete, initialInvoiceNinja }) {
  const [error, setError] = useState({
    invoiceNinjaKey: '',
    invoiceNinjaUrl: '',
  });
  const { details, id: invoiceNinjaId = '' } = initialInvoiceNinja || {};
  const [isEditing, setIsEditing] = useState(!initialInvoiceNinja);
  const { credentials, url: invoiceNinjaUrl = '' } = details || {};
  const { apikey: invoiceNinjaKey = '' } = credentials || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [state, setState] = useState({ invoiceNinjaKey, invoiceNinjaUrl });

  function onEditToggle() {
    setIsEditing(!isEditing);
  }

  function onDeleteInvoiceNinja() {
    onDelete(invoiceNinjaId, { id: invoiceNinjaId, type: INVOICE_NINJA });
  }

  function onInputChange(event) {
    const { currentTarget } = event;
    const { name, value } = currentTarget;
    setState({ ...state, [name]: value });
  }

  function onSubmitInvoiceNinjaKey() {
    setIsSubmitting(true);
    const { invoiceNinjaKey, invoiceNinjaUrl } = state;
    if (validateInvoiceForm()) {
      const save = {
        type: INVOICE_NINJA,
        details: {
          url: invoiceNinjaUrl,
          credentials: { apikey: invoiceNinjaKey },
        },
      };
      const update = {
        id: invoiceNinjaId,
        details: {
          url: invoiceNinjaUrl,
          credentials: { apikey: invoiceNinjaKey },
        },
      };
      const data = invoiceNinjaId ? update : save;
      onSubmit(data, INVOICE_NINJA, invoiceNinjaId);
    }
  }

  function validateInvoiceForm() {
    let isFormValid = true;
    let errorObject = { ...error };
    for (const [key, value] of Object.entries(state)) {
      if (!value) {
        isFormValid = false;
        errorObject = {
          ...errorObject,
          [key]: `${capitalizeFirstLetter(key, true)} is required`,
        };
      } else {
        errorObject = { ...errorObject, [key]: '' };
      }
    }
    const hasInvalidUrl =
      state.invoiceNinjaUrl && !isValidUrl(state.invoiceNinjaUrl);
    if (hasInvalidUrl) {
      isFormValid = false;
      errorObject = { ...errorObject, invoiceNinjaUrl: 'Invalid url' };
    }
    setError(errorObject);
    return isFormValid;
  }

  useEffect(() => {
    if (isSubmitting) {
      validateInvoiceForm();
    }
  }, [state, isSubmitting]);

  return (
    <Collapsible caption="Invoice Ninja">
      <FormGroup>
        <FlexRow>
          <FlexCol flexWidth={12}>
            <TextInput
              isRequired
              caption="Url"
              inputType="text"
              disabled={!isEditing}
              name="invoiceNinjaUrl"
              onChange={onInputChange}
              inputId="invoiceNinjaUrl"
              value={state.invoiceNinjaUrl}
              errorMessage={error.invoiceNinjaUrl}
              placeholder="Enter invoice ninja url"
            />
          </FlexCol>
        </FlexRow>
        <FlexRow>
          <FlexCol flexWidth={12}>
            <TextInput
              isRequired
              caption="API Key"
              disabled={!isEditing}
              name="invoiceNinjaKey"
              onChange={onInputChange}
              inputId="invoiceNinjaKey"
              value={state.invoiceNinjaKey}
              errorMessage={error.invoiceNinjaKey}
              placeholder="Enter invoice ninja key"
              inputType={isEditing ? 'text' : 'password'}
            />
          </FlexCol>
        </FlexRow>
      </FormGroup>
      <FlexRow>
        <FlexCol flexWidth={4}>
          <CancelButton
            icon={<EditIcon />}
            onClick={onEditToggle}
            className="modal-button"
            caption={`${isEditing ? 'Disable' : 'Enable'} Editing`}
          />
        </FlexCol>
        <FlexCol flexWidth={4}>
          <RoundButton
            caption="Save"
            icon={<ArrowIcon />}
            className="modal-button"
            onClick={onSubmitInvoiceNinjaKey}
          />
        </FlexCol>
        <FlexCol flexWidth={4}>
          <DeleteButton
            caption="Delete"
            icon={<ArrowIcon />}
            className="modal-button"
            isDisabled={!invoiceNinjaId}
            onClick={onDeleteInvoiceNinja}
          />
        </FlexCol>
      </FlexRow>
    </Collapsible>
  );
}
